import styled from 'styled-components';

export const HeadingContainer = styled.div`
  display: inline-block;
  width: 100%;
  padding: 2em 4em;

  @media (max-width: 720px) {
    padding: 2em 1em;
  }
`;

export const TagListHeading = styled.div`
  background: #d0effa;
  text-align: center;
  padding: 3em 4em;
  position: relative;

  @media (max-width: 720px) {
    padding: 2em 1em;
  }

  & h1 {
    font-size: clamp(2rem, 3vw, 4rem);
    font-weight: 700;
    text-transform: uppercase;
    color: #6e6e6e;
    padding-bottom: 16px;
  }

  & p {
    font-size: clamp(14px, 1.4vw, 18px);
    color: #6e6e6e;
    padding-bottom: 16px;
  }

  img {
    width: 100%;
    position: absolute;
    bottom: -30px;
    left: 0;

    @media (max-width: 720px) {
      bottom: 0;
    }
  }
`;
